import { AuthorityLevels } from '../enums';
import { FirebaseEmptyField } from '../types/firebase-empty-field';
import { User } from '../types/app';

export const firebaseSystemUser = {
  id: 'FIREBASE_SYSTEM_USER',
  user: {
    id: 'FIREBASE_SYSTEM_USER',
    authorityLevel: AuthorityLevels.Owner,
    email: '',
    name: 'System'
  } as User
};

export const firebaseEmptyField = 'FIREBASE_EMPTY_FIELD' as FirebaseEmptyField;
